<template>
    <breakpoint>
        <main slot-scope="media">
            <a-layout
                id="dashboard-nav"
                ref="nav"
                :class="{ smDown: media.smDown }"
                style="min-height: 100vh"
            >
                <a-layout-sider collapsible v-model="collapsed">
                    <div v-if="admin && !collapsed" class="logo">
                        <a-dropdown overlayClassName="current-admin">
                            <a
                                class="ant-dropdown-link"
                                @click="e => e.preventDefault()"
                            >
                                <a-avatar
                                    shape="square"
                                    icon="user"
                                    :src="admin.profilePicUrl"
                                />
                                <p class="user-dropdown">
                                    @{{ admin.username }}
                                </p>
                                <a-icon type="down" />
                            </a>
                            <a-menu slot="overlay">
                                <a-menu-item>
                                    <router-link
                                        :to="{
                                            name: 'admin-update',
                                            params: { id: admin.id }
                                        }"
                                    >
                                        Edit Profile
                                    </router-link>
                                </a-menu-item>
                                <a-menu-item>
                                    <a @click="doLogout">Logout</a>
                                </a-menu-item>
                            </a-menu>
                        </a-dropdown>
                    </div>
                    <a-menu
                        theme="dark"
                        :open-keys="openKeys"
                        v-model="selectedKeys"
                        :defaultSelectedKeys="defaultSelectedKeys"
                        mode="inline"
                        @openChange="onOpenChange"
                    >
                        <a-sub-menu
                            v-if="admin && collapsed"
                            key="current-admin"
                        >
                            <span slot="title">
                                <a-avatar
                                    :size="24"
                                    icon="user"
                                    :src="admin.profilePicUrl"
                                />
                            </span>
                            <a-menu-item key="/manage-admin">
                                <router-link
                                    :to="{
                                        name: 'admin-update',
                                        params: { id: admin.id }
                                    }"
                                >
                                    Edit Profile
                                </router-link>
                            </a-menu-item>
                            <a-menu-item key="logout">
                                <a @click="doLogout">Logout</a>
                            </a-menu-item>
                        </a-sub-menu>
                        <a-menu-item key="/">
                            <router-link to="/">
                                <a-icon type="dashboard" />
                                <span>Dashboard</span>
                            </router-link>
                        </a-menu-item>
                        <a-sub-menu key="manage-member">
                            <span slot="title"
                                ><a-icon type="user" /><span>Member</span></span
                            >
                            <a-menu-item key="/manage-member">
                                <router-link to="/manage-member">
                                    <span>Manage</span>
                                </router-link>
                            </a-menu-item>
                            <a-menu-item key="/manage-member/member-report">
                                <router-link to="/manage-member/member-report">
                                    <span>Reports</span>
                                </router-link>
                            </a-menu-item>
                            <a-menu-item key="/manage-member/member-advicement">
                                <router-link
                                    to="/manage-member/member-advicement"
                                >
                                    <span>Advicements</span>
                                </router-link>
                            </a-menu-item>
                        </a-sub-menu>
                        <a-sub-menu key="manage-professional">
                            <span slot="title"
                                ><a-icon type="user" /><span
                                    >Professional</span
                                ></span
                            >
                            <a-menu-item key="/manage-professional/list">
                                <router-link to="/manage-professional/list">
                                    <span>Manage</span>
                                </router-link>
                            </a-menu-item>
                            <!-- <a-menu-item key="/manage-professional/verification-request">
                <router-link to="/manage-professional/verification-request">
                  <span>Verification Requests</span>
                </router-link>
              </a-menu-item> -->
                            <a-menu-item key="/manage-professional/profession">
                                <router-link
                                    to="/manage-professional/profession"
                                >
                                    <span>Professions & Skills</span>
                                </router-link>
                            </a-menu-item>
                            <a-menu-item
                                key="/manage-professional/survei-request"
                            >
                                <router-link
                                    to="/manage-professional/survei-request"
                                >
                                    <span>Survei Request</span>
                                </router-link>
                            </a-menu-item>
                            <a-menu-item
                                key="/manage-professional/professional-service-list"
                            >
                                <router-link
                                    to="/manage-professional/professional-service-list"
                                >
                                    <span>Services</span>
                                </router-link>
                            </a-menu-item>
                            <a-menu-item
                                key="/manage-professional/direct-order"
                            >
                                <router-link
                                    to="/manage-professional/direct-order"
                                >
                                    <span>DO & Complain</span>
                                </router-link>
                            </a-menu-item>
                            <a-menu-item
                                key="/manage-professional/client-complain"
                            >
                                <router-link
                                    to="/manage-professional/client-complain"
                                >
                                    <span>PO & Complain</span>
                                </router-link>
                            </a-menu-item>
                            <!-- <a-menu-item key="/manage-professional/survei-request">
                <router-link to="/manage-professional/survei-request">
                  <span>Survei Request</span>
                </router-link>
              </a-menu-item>
              <a-menu-item key="/manage-professional/client-complain">
                <router-link to="/manage-professional/client-complain">
                  <span>Client Complain</span>
                </router-link>
              </a-menu-item> -->
                        </a-sub-menu>
                        <a-sub-menu key="manage-admin">
                            <span slot="title"
                                ><a-icon type="customer-service" /><span
                                    >Admin</span
                                ></span
                            >
                            <a-menu-item key="/manage-admin">
                                <router-link to="/manage-admin">
                                    <span>Manage</span>
                                </router-link>
                            </a-menu-item>
                            <a-menu-item key="/manage-admin/invite">
                                <router-link to="/manage-admin/invite">
                                    <span>Invite</span>
                                </router-link>
                            </a-menu-item>
                            <a-menu-item key="/manage-admin/permission">
                                <router-link to="/manage-admin/permission">
                                    <span>Permission</span>
                                </router-link>
                            </a-menu-item>
                            <a-menu-item key="/manage-admin/roles">
                                <router-link to="/manage-admin/roles">
                                    <span>Admin Role</span>
                                </router-link>
                            </a-menu-item>
                            <a-menu-item key="/manage-admin/activity-log">
                                <router-link to="/manage-admin/activity-log">
                                    <span>Logs</span>
                                </router-link>
                            </a-menu-item>
                        </a-sub-menu>
                        <a-sub-menu key="manage-membership">
                            <span slot="title"
                                ><a-icon type="reconciliation" /><span
                                    >Membership</span
                                ></span
                            >
                            <a-menu-item key="/manage-membership">
                                <router-link to="/manage-membership">
                                    <span>Manage</span>
                                </router-link>
                            </a-menu-item>
                            <a-menu-item key="/manage-membership/create">
                                <router-link to="/manage-membership/create">
                                    <span>Create</span>
                                </router-link>
                            </a-menu-item>
                        </a-sub-menu>
                        <a-sub-menu key="manage-advertisement">
                            <span slot="title"
                                ><a-icon type="notification" /><span
                                    >Advertisements</span
                                ></span
                            >
                            <a-menu-item
                                key="/manage-advertisement/advertisement/property-list"
                            >
                                <router-link
                                    to="/manage-advertisement/advertisement/property-list"
                                >
                                    <span>Manage Properties</span>
                                </router-link>
                            </a-menu-item>
                            <a-menu-item
                                key="/manage-advertisement/advertisement/project-list"
                            >
                                <router-link
                                    to="/manage-advertisement/advertisement/project-list"
                                >
                                    <span>Manage Projects</span>
                                </router-link>
                            </a-menu-item>
                            <a-menu-item
                                key="/manage-advertisement/advertisement/property-create"
                            >
                                <router-link
                                    to="/manage-advertisement/advertisement/property-create"
                                >
                                    <span>Create Property</span>
                                </router-link>
                            </a-menu-item>
                            <a-menu-item
                                key="/manage-advertisement/advertisement/project-create"
                            >
                                <router-link
                                    to="/manage-advertisement/advertisement/project-create"
                                >
                                    <span>Create Project</span>
                                </router-link>
                            </a-menu-item>
                        </a-sub-menu>
                        <a-sub-menu key="manage-order">
                            <span slot="title"
                                ><a-icon type="dollar" /><span
                                    >Financials</span
                                ></span
                            >
                            <a-menu-item
                                key="/manage-order/membership-order-list"
                            >
                                <router-link
                                    to="/manage-order/membership-order-list"
                                >
                                    <span>Membership Order</span>
                                </router-link>
                            </a-menu-item>
                            <a-menu-item key="/manage-order/topup-order-list">
                                <router-link
                                    to="/manage-order/topup-order-list"
                                >
                                    <span>Topup Order</span>
                                </router-link>
                            </a-menu-item>
                            <a-menu-item key="/manage-payout/list">
                                <router-link to="/manage-payout/list">
                                    <span>Payout</span>
                                </router-link>
                            </a-menu-item>
                            <a-menu-item key="/manage-order/wallet-histories">
                                <router-link to="/manage-order/wallet-histories">
                                    <span>Wallet Histories</span>
                                </router-link>
                            </a-menu-item>
                            <a-menu-item key="/manage-referral/member-referral">
                                <router-link
                                    to="/manage-referral/member-referral"
                                >
                                    <span>Referral Logs</span>
                                </router-link>
                            </a-menu-item>
                        </a-sub-menu>
                        <a-sub-menu key="manage-crowdfund">
                            <span slot="title"
                                ><a-icon type="global" /><span
                                    >Crowdfund</span
                                ></span
                            >
                            <a-menu-item key="/manage-crowdfund/list">
                                <router-link to="/manage-crowdfund/list">
                                    <span>Manage</span>
                                </router-link>
                            </a-menu-item>
                            <a-menu-item key="/manage-crowdfund/investors">
                                <router-link to="/manage-crowdfund/investors">
                                    <span>Investors</span>
                                </router-link>
                            </a-menu-item>
                            <a-menu-item key="/manage-crowdfund/propose">
                                <router-link to="/manage-crowdfund/propose">
                                    <span>Create Proposal</span>
                                </router-link>
                            </a-menu-item>
                            <a-menu-item
                                key="/manage-crowdfund/marketplace-list"
                            >
                                <router-link
                                    to="/manage-crowdfund/marketplace-list"
                                >
                                    <span>Marketplace</span>
                                </router-link>
                            </a-menu-item>
                            <a-menu-item key="/manage-crowdfund/broadcasts">
                                <router-link to="/manage-crowdfund/broadcasts">
                                    <span>Broadcasts</span>
                                </router-link>
                            </a-menu-item>
                            <a-menu-item
                                key="/manage-crowdfund/convert-request"
                            >
                                <router-link
                                    to="/manage-crowdfund/convert-request"
                                >
                                    <span>Convert Request</span>
                                </router-link>
                            </a-menu-item>
                        </a-sub-menu>
                        <a-sub-menu key="manage-setting">
                            <span slot="title"
                                ><a-icon type="setting" /><span
                                    >Settings</span
                                ></span
                            >
                            <a-menu-item
                                key="/manage-setting/internal-setting-update"
                            >
                                <router-link
                                    to="/manage-setting/internal-setting-update"
                                >
                                    <span>Internal Setting</span>
                                </router-link>
                            </a-menu-item>
                            <a-menu-item
                                key="/manage-setting/consume-setting-update"
                            >
                                <router-link
                                    to="/manage-setting/consume-setting-update"
                                >
                                    <span>Consume Setting</span>
                                </router-link>
                            </a-menu-item>
                        </a-sub-menu>
                        <a-sub-menu key="manage-cms">
                            <span slot="title"
                                ><a-icon type="file-sync" /><span
                                    >CMS</span
                                ></span
                            >
                            <a-menu-item key="/manage-cms/basic-info">
                                <router-link to="/manage-cms/basic-info">
                                    <span>Basic Info</span>
                                </router-link>
                            </a-menu-item>
                            <a-menu-item key="/manage-cms/home-page">
                                <router-link to="/manage-cms/home-page">
                                    <span>Home Page</span>
                                </router-link>
                            </a-menu-item>
                            <a-menu-item key="/manage-cms/compro">
                                <router-link to="/manage-cms/compro">
                                    <span>Company Profile</span>
                                </router-link>
                            </a-menu-item>
                            <a-menu-item key="/manage-cms/our-team-list">
                                <router-link to="/manage-cms/our-team-list">
                                    <span>Our Team</span>
                                </router-link>
                            </a-menu-item>
                            <a-menu-item key="/manage-cms/hiw-agent-referral">
                                <router-link
                                    to="/manage-cms/hiw-agent-referral"
                                >
                                    <span>HIW Agent & Referral</span>
                                </router-link>
                            </a-menu-item>
                            <a-menu-item key="/manage-cms/hiw-crowdinvest">
                                <router-link to="/manage-cms/hiw-crowdinvest">
                                    <span>HIW Crowdinvest</span>
                                </router-link>
                            </a-menu-item>
                            <a-menu-item key="/manage-cms/hiw-professional">
                                <router-link to="/manage-cms/hiw-professional">
                                    <span>HIW Professional</span>
                                </router-link>
                            </a-menu-item>
                            <a-menu-item key="/manage-cms/faq">
                                <router-link to="/manage-cms/faq">
                                    <span>FAQ</span>
                                </router-link>
                            </a-menu-item>
                            <a-menu-item key="/manage-cms/tnc">
                                <router-link to="/manage-cms/tnc">
                                    <span>TnC</span>
                                </router-link>
                            </a-menu-item>
                            <a-menu-item key="/manage-cms/risk-and-warning">
                                <router-link to="/manage-cms/risk-and-warning">
                                    <span>Risk and Warning</span>
                                </router-link>
                            </a-menu-item>
                            <a-menu-item key="/manage-cms/cookie-policy">
                                <router-link to="/manage-cms/cookie-policy">
                                    <span>Cookie Policy</span>
                                </router-link>
                            </a-menu-item>
                            <a-menu-item key="/manage-cms/privacy-policy">
                                <router-link to="/manage-cms/privacy-policy">
                                    <span>Privacy Policy</span>
                                </router-link>
                            </a-menu-item>
                            <a-menu-item key="/manage-cms/company-list">
                                <router-link to="/manage-cms/company-list">
                                    <span>Agent Company List</span>
                                </router-link>
                            </a-menu-item>
                            <a-menu-item key="/manage-cms/membership-desc">
                                <router-link to="/manage-cms/membership-desc">
                                    <span>Membership Desc</span>
                                </router-link>
                            </a-menu-item>
                        </a-sub-menu>
                        <a-menu-item key="/statistic">
                            <router-link to="/statistic">
                                <a-icon type="bar-chart" />
                                <span>Statistic</span>
                            </router-link>
                        </a-menu-item>
                        <a-sub-menu key="manage-notification">
                            <span slot="title"
                                ><a-icon type="file-sync" /><span
                                    >Notification</span
                                ></span
                            >
                            <a-menu-item key="/manage-notification/broadcast">
                                <router-link
                                    to="/manage-notification/broadcast"
                                >
                                    <span>Broadcast</span>
                                </router-link>
                            </a-menu-item>
                        </a-sub-menu>
                    </a-menu>
                </a-layout-sider>
                <a-layout>
                    <a-layout-header style="background: #fff; padding: 0" />
                    <a-layout-content style="margin: 0 16px">
                        <slot name="breadcrumb" />
                        <div class="content-wrapper">
                            <slot></slot>
                        </div>
                    </a-layout-content>
                    <a-layout-footer style="text-align: center">
                        PropertiGrab Admin Dashboard.
                    </a-layout-footer>
                </a-layout>
            </a-layout>
        </main>
    </breakpoint>
</template>

<script>
import AdminMixin from 'mixins/admin';
import './ant-design-overwrite.scss';

export default {
    name: 'input-wrapper',
    props: {
        withNav: {
            type: Boolean,
            default: true
        }
    },
    mixins: [AdminMixin],
    data: () => {
        return {
            isSmDown: false,
            collapsed: true,
            mode: 'vertical',
            defaultSelectedKeys: [''],
            selectedKeys: [''],
            openKeys: [],
            rootSubmenuKeys: [
                '/',
                'current-admin',
                'manage-member',
                'manage-professional',
                'manage-admin',
                'manage-membership',
                'manage-advertisement',
                'manage-order',
                'manage-crowdfund',
                'manage-setting',
                'manage-cms',
                'manage-notification'
            ],
            admin: undefined
        };
    },
    watch: {
        $route(to, from) {
            this.setCurrentRouteConfigs();
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.checkDisplaySize();
            this.setCollapsedValue();
            this.setCurrentRouteConfigs();
            this.getCurrentAdmin();
        });
    },
    methods: {
        getCurrentAdmin() {
            this.admin = JSON.parse(this._getCurrentAdmin());
        },
        checkDisplaySize() {
            let navDom = this.$refs.nav;
            this.isSmDown = navDom.$el.classList.contains('smDown')
                ? true
                : false;
        },
        setCollapsedValue() {
            this.collapsed = this.isSmDown;
        },
        findParentSubmenuKey(path) {
            // Map route paths to their parent submenu keys
            if (path === '/' || path === '/statistic') {
                return null; // Root level menu items
            }

            if (path.startsWith('/manage-membership')) {
                return 'manage-membership';
            }
            if (path.startsWith('/manage-member')) {
                return 'manage-member';
            }
            if (path.startsWith('/manage-professional')) {
                return 'manage-professional';
            }
            if (path.startsWith('/manage-admin')) {
                return 'manage-admin';
            }
            if (path.startsWith('/manage-advertisement')) {
                return 'manage-advertisement';
            }
            if (
                path.startsWith('/manage-order') ||
                path.startsWith('/manage-payout') ||
                path.startsWith('/manage-referral')
            ) {
                return 'manage-order';
            }
            if (path.startsWith('/manage-crowdfund')) {
                return 'manage-crowdfund';
            }
            if (path.startsWith('/manage-setting')) {
                return 'manage-setting';
            }
            if (path.startsWith('/manage-cms')) {
                return 'manage-cms';
            }
            if (path.startsWith('/manage-notification')) {
                return 'manage-notification';
            }

            return null;
        },
        setCurrentRouteConfigs() {
            const currentPath = this.$route.path;

            // Find and open parent submenu
            const parentSubmenuKey = this.findParentSubmenuKey(currentPath);

            // Determine selected menu item key
            let selectedKey = currentPath;

            // For routes with parameters or nested routes, find the best matching menu item
            if (parentSubmenuKey) {
                // investment-broadcast has no menu item; treat as Broadcasts
                if (
                    parentSubmenuKey === 'manage-crowdfund' &&
                    currentPath === '/manage-crowdfund/investment-broadcast'
                ) {
                    selectedKey = '/manage-crowdfund/broadcasts';
                } else {
                    const menuItemKeys = this.getMenuItemKeysForSubmenu(
                        parentSubmenuKey
                    );

                    // First, check for exact match
                    const exactMatch = menuItemKeys.find(
                        key => currentPath === key
                    );
                    if (exactMatch) {
                        selectedKey = exactMatch;
                    } else {
                        // Try to find a match by checking if path starts with menu item key
                        // Sort by length (longest first) to match more specific routes first
                        const sortedKeys = menuItemKeys.sort(
                            (a, b) => b.length - a.length
                        );
                        const prefixMatch = sortedKeys.find(
                            key => {
                                // Check exact match
                                if (currentPath === key) return true;
                                // Check if path starts with key + '/' (for nested routes)
                                if (currentPath.startsWith(key + '/')) return true;
                                // Check if path starts with key + '-' (for routes like direct-order-track-progress)
                                if (currentPath.startsWith(key + '-')) return true;
                                return false;
                            }
                        );

                        if (prefixMatch) {
                            selectedKey = prefixMatch;
                        } else {
                            // For routes with parameters (e.g., /manage-crowdfund/123/update),
                            // use the default list route to indicate we're in that section
                            selectedKey = this.getDefaultMenuItemKey(
                                parentSubmenuKey
                            );
                        }
                    }
                }
            }

            // Set selected menu item key
            this.selectedKeys = [selectedKey];

            if (parentSubmenuKey && !this.isSmDown) {
                // Auto-open parent submenu on desktop
                this.openKeys = [parentSubmenuKey];
            } else if (this.isSmDown) {
                // Keep closed on mobile
                this.openKeys = [];
            } else {
                // For root level items, keep current openKeys or default
                this.openKeys = [];
            }
        },
        getMenuItemKeysForSubmenu(submenuKey) {
            // Return array of menu item keys for a given submenu
            const menuItemMap = {
                'manage-member': [
                    '/manage-member',
                    '/manage-member/member-report',
                    '/manage-member/member-advicement'
                ],
                'manage-professional': [
                    '/manage-professional/list',
                    '/manage-professional/profession',
                    '/manage-professional/survei-request',
                    '/manage-professional/professional-service-list',
                    '/manage-professional/direct-order',
                    '/manage-professional/client-complain'
                ],
                'manage-admin': [
                    '/manage-admin',
                    '/manage-admin/invite',
                    '/manage-admin/permission',
                    '/manage-admin/roles',
                    '/manage-admin/activity-log'
                ],
                'manage-membership': [
                    '/manage-membership',
                    '/manage-membership/create'
                ],
                'manage-advertisement': [
                    '/manage-advertisement/advertisement/property-list',
                    '/manage-advertisement/advertisement/project-list',
                    '/manage-advertisement/advertisement/property-create',
                    '/manage-advertisement/advertisement/project-create'
                ],
                'manage-order': [
                    '/manage-order/membership-order-list',
                    '/manage-order/topup-order-list',
                    '/manage-payout/list',
                    '/manage-order/wallet-histories',
                    '/manage-referral/member-referral'
                ],
                'manage-crowdfund': [
                    '/manage-crowdfund/list',
                    '/manage-crowdfund/investors',
                    '/manage-crowdfund/propose',
                    '/manage-crowdfund/marketplace-list',
                    '/manage-crowdfund/broadcasts',
                    '/manage-crowdfund/convert-request'
                ],
                'manage-setting': [
                    '/manage-setting/internal-setting-update',
                    '/manage-setting/consume-setting-update'
                ],
                'manage-cms': [
                    '/manage-cms/basic-info',
                    '/manage-cms/home-page',
                    '/manage-cms/compro',
                    '/manage-cms/our-team-list',
                    '/manage-cms/hiw-agent-referral',
                    '/manage-cms/hiw-crowdinvest',
                    '/manage-cms/hiw-professional',
                    '/manage-cms/faq',
                    '/manage-cms/tnc',
                    '/manage-cms/risk-and-warning',
                    '/manage-cms/cookie-policy',
                    '/manage-cms/privacy-policy',
                    '/manage-cms/company-list',
                    '/manage-cms/membership-desc'
                ],
                'manage-notification': ['/manage-notification/broadcast']
            };

            return menuItemMap[submenuKey] || [];
        },
        getDefaultMenuItemKey(submenuKey) {
            // Return default menu item key for a submenu (usually the list/manage route)
            const defaultKeys = {
                'manage-member': '/manage-member',
                'manage-professional': '/manage-professional/list',
                'manage-admin': '/manage-admin',
                'manage-membership': '/manage-membership',
                'manage-advertisement':
                    '/manage-advertisement/advertisement/property-list',
                'manage-order': '/manage-order/membership-order-list',
                'manage-crowdfund': '/manage-crowdfund/list',
                'manage-setting': '/manage-setting/internal-setting-update',
                'manage-cms': '/manage-cms/basic-info',
                'manage-notification': '/manage-notification/broadcast'
            };

            return defaultKeys[submenuKey] || '/';
        },
        onOpenChange(openKeys) {
            const latestOpenKey = openKeys.find(
                key => this.openKeys.indexOf(key) === -1
            );
            if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
                this.openKeys = openKeys;
            } else {
                this.openKeys = latestOpenKey ? [latestOpenKey] : [];
            }
        },
        doLogout() {
            localStorage.removeItem('accessToken');
            localStorage.removeItem('rme');
            localStorage.removeItem('rpem');
            this.$router.push('/login');
            this.$message.success('Logout successfully!', 3);
            this.$emit('logout');
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#dashboard-nav .logo {
    height: 32px;
    background: rgba(0, 0, 0, 0.2);
    margin: 16px;
    border-radius: 12px;
}

.user-dropdown {
    width: 100px;
    margin-left: 8px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-flex;
}

.content-wrapper {
    padding: 24px;
    background: #fff;
    min-height: 70vh;
}

// Mobile View
@media only screen and (min-device-width: 0px) and (max-device-width: 699px) {
    .content-wrapper {
        padding: 8px;
    }
}
</style>
